import { render, staticRenderFns } from "./PackagingTypesEdit.vue?vue&type=template&id=30e6a96f&scoped=true"
import script from "./PackagingTypesEdit.vue?vue&type=script&lang=js"
export * from "./PackagingTypesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e6a96f",
  null
  
)

export default component.exports